// extracted by mini-css-extract-plugin
export default {"alertMessage":"AddManagementPermission_alertMessage__YatY9"};